import { useState } from "react";
import "@/App.css";
import LoadingScreen from "@/components/LoadingScreen";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Story from "@/components/Story";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import TikTokSection from "@/components/TikTokSection";
import BookingCTA from "@/components/BookingCTA";
import Reviews from "@/components/Reviews";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import { ScrollProgress, CursorGlow } from "@/components/Effects";
import { Toaster } from "sonner";

function App() {
  const [loading, setLoading] = useState(true);

  return (
    <div className="App">
      {loading && <LoadingScreen onDone={() => setLoading(false)} />}
      <ScrollProgress />
      <CursorGlow />
      <Navigation />
      <main>
        <Hero />
        <Story />
        <Services />
        <Gallery />
        <TikTokSection />
        <BookingCTA />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <CookieBanner />
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#181818", border: "1px solid rgba(201,168,76,0.3)", color: "#F5F0E8" } }} />
    </div>
  );
}

export default App;
